<ng-container *ngIf="modalConfig$ | async as modalConfig">
  <div
    *ngIf="modalConfig.show"
    class="modal-base"
    [class.close-in-progress]="onCloseStylesAnimationInProgress"
  >
    <div class="modal-content" [class.close-in-progress]="onCloseStylesAnimationInProgress">
      <div class="container-close">
        <div class="close-button">
          <img
            src="/assets/img/icon/black-close-button.svg"
            alt="Botón X para cerrar"
            (click)="onClose()"
          />
        </div>
      </div>
      <ng-container [ngTemplateOutlet]="modalConfig.templateRef"></ng-container>
    </div>
  </div>
</ng-container>
